import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from '../Services/user.service';
import {environment} from '../../environments/environment';
@Component({
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.scss'],
  providers: [UserService]
})
export class VerifyAccountComponent implements OnInit {
  userId: string;
  code: string;
  newPassword: string;
  confirmPassword: string;
  private sub: any;
  passwordChanged: boolean;
  showErrorMsg: boolean;
  portalUrl: string = environment.main_url;
  responseType = '';

  constructor(private userService: UserService, private route: ActivatedRoute) {
    this.passwordChanged = false;
    this.showErrorMsg = false;
  }

  ngOnInit() {
    this.sub = this.route.queryParams.subscribe(params => {
      this.userId = params['userId'];
      this.code = params['code']; // (+) converts string 'id' to a number

      // In a real app: dispatch action to load the details here.
    });
  }

  ResetPassword() {
    if (this.newPassword === this.confirmPassword) {
      this.showErrorMsg = false;
      this.userService.verifyAccount(this.userId, this.code, this.newPassword).subscribe(x => {
          this.passwordChanged = true;
          if (typeof x === 'string') {
            if (x === 'Succeeded False') {
              this.responseType = 'success-failed';
            } else {
              this.responseType = 'success';
            }
          } else {
            this.responseType = 'error';
            this.passwordChanged = false;
          }
      },
        error => {
          this.responseType = 'error';

        }
      );
    } else {
      this.showErrorMsg = true;
    }
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/verify-account/verify-account.component.ts